//store/modules/auth.js
import axios from "axios";
import Vue from "vue";
import router from "../../router";
import { CometChat } from "@cometchat-pro/chat";

const state = {
  user: {
    token: null,
    data: {
      uuid: null,
    },
  },
  interests: [],
  premium: false,
  premiumModal: false,
  premiumLayout: false,
  searchFilterByStatus: false,
  mainLoader: false,
  premiumNav: false,
  logOutLoading: false,
};
const getters = {
  token: (state) => state.user.token,
  isAuthenticated: (state) => !!state.user.token,
  isPremium: (state) => state.user.data.plan_name === "premium",
  isPremiumModalOpened: (state) => !!state.premiumModal,
  isStatus: (state) => !!state.searchFilterByStatus,
  isPremiumLayout: (state) => !!state.premiumLayout,
  premiumNav: (state) => !!state.premiumNav,
  interests: (state) => state.interests,
  StateUser: (state) => state.user,
  getCometUUID: (state) => state.user.data.uuid,
  isLoading: (state) => state.mainLoader,
  getLogOutLoading: (state) => state.logOutLoading,
};

const actions = {
  premiumNav({ commit }) {
    commit("changepremiumNavState");
  },
  premium({ commit }) {
    commit("changePremiumState");
  },
  premiumModalFn({ commit } , data) {
    commit("changePremiumModalState" , data);
  },
  searchFilterByStatus({ commit }) {
    commit("changeSearchFilterState");
  },
  setloading({ commit }, data) {
    commit("SETLOADING", data);
  },
  premiumLayout({ commit } , data) {
    localStorage.setItem("premiumLayout", JSON.stringify(data));
    commit("changePremiumLayoutState" , data);
  },
  async LogIn({ commit, dispatch }, User) {
    try {
      const login = await axios.post("auth/login", User);
      await commit("setUser", login.data);
      await commit("setToken", login.data);
      const types = {
        1: "lesbian",
        2: "gay",
        3: "straight",
      };
      await dispatch("GetSettings", { root: true });
      const userType = types[login.data.data.account_type];
      const userPlan = login.data.data.plan_name;
      if (!userType) router.push("/interest");
      else if (!userPlan) router.push("/plan");
      else router.push(`/${userType}/profiles`);
    } catch (error) {
      await dispatch("errorAction", error.response.data.message, {
        root: true,
      });
    }
  },
  async Register({ dispatch }, form) {
    try {
      const { full_name, email, password, password_confirmation, role } = form;
      await axios.post("auth/register", {
        full_name,
        email,
        password,
        password_confirmation,
        role,
      });
      await dispatch("LogIn", { email, password });
      // router.push("/straight/profiles")
    } catch (error) {
      await dispatch("errorAction", error.response.data.message, {
        root: true,
      });
    }
  },
  async LogOut({ commit, state }) {
    // console.log(state.user.data.token)
    try {
      state.logOutLoading = true;
      CometChat.logout().then(
        () => {
          return console.log("Logout completed successfully");
        },
        (error) => {
          return console.log("Logout failed with exception:", { error });
        }
      );
      await axios.get("auth/logout", {
        headers: { Authorization: `Bearer ${state.user.token}` },
      });

      localStorage.clear("userInfo");
      await router.push("/login");
      commit("LogOut");
      state.premiumLayout = false;
    } catch (error) {
      console.log(error);
    } finally {
      state.logOutLoading = false;
    }
  },
  async restoreData({ commit }, data) {
    commit("setUser", data);
  },
  async getInterests({ commit }) {
    try {
      const resp = await axios.get("interests");

      commit("setInterests", resp.data.data);
    } catch (error) {}
  },
};
const mutations = {
  setInterests(state, data) {
    state.interests = data;
  },
  setUser(state, userDetails) {
    localStorage.setItem("userInfo", JSON.stringify(userDetails));
    console.log(userDetails);
    state.user.data = userDetails.data;
  },
  setToken(state, userDetails) {
    localStorage.setItem("token", JSON.stringify(userDetails));
    state.user.token = userDetails.data.token;
  },
  LogOut(state) {
    state.user.token = null;
  },
  logger(state) {
    state.user = true;
  },
  changePremiumState(state) {
    state.premium = !state.premium;
  },
  changePremiumModalState(state , data) {
    state.premiumModal = data;
  },
  changepremiumNavState(state) {
    state.premiumNav = !state.premiumNav;
  },
  changeSearchFilterState(state) {
    state.searchFilterByStatus = !state.searchFilterByStatus;
  },
  changePremiumLayoutState(state , data) {
    state.premiumLayout = data;
  },
  SETLOADING(state, data) {
    state.mainLoader = data;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
